import { render, staticRenderFns } from "./KusBaseError.vue?vue&type=template&id=d7ef9d16"
import script from "./KusBaseError.vue?vue&type=script&lang=js"
export * from "./KusBaseError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports